import { Send } from "lucide-react";

export default function ChatInput({ input, setInput, onSend, onReset, streaming }) {
  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend(); }
  };
  return (
    <div className="border-t border-stone-200 bg-white p-3">
      <div className="flex items-end gap-2">
        <textarea
          data-testid="chat-input"
          rows={1}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={onKey}
          placeholder="Ask about peptides, labs, or scheduling…"
          className="flex-1 resize-none border border-stone-200 rounded-xl px-3 py-2 text-sm outline-none focus:border-[color:var(--vv-gold)] max-h-24"
        />
        <button
          data-testid="chat-send"
          onClick={() => onSend()}
          disabled={!input.trim() || streaming}
          aria-label="Send message"
          className="w-9 h-9 rounded-full bg-[color:var(--vv-gold)] text-[color:var(--vv-gold-deeper)] grid place-items-center disabled:opacity-40 hover:bg-[color:var(--vv-gold-hover)]"
        >
          <Send size={15} />
        </button>
      </div>
      <div className="mt-2 flex items-center justify-between text-[10px] text-stone-500">
        <button data-testid="chat-reset" onClick={onReset} className="hover:text-stone-800">Start new chat</button>
        <a href="tel:+18887738677" className="font-semibold text-[color:var(--vv-gold-deep)] hover:text-[color:var(--vv-gold-deeper)]">
          Or call (888) 773-8677
        </a>
      </div>
    </div>
  );
}
